/* eslint-disable no-restricted-syntax -- this line was auto generated, hence fix the issue timely */
import React, { FC } from "react";
import { UIBrandedFareInfo, UIFlightData } from "@flights/types";
import Frame from "../../../../Frame";
import { useFlightCardLuggageController } from "./useFlightCardLuggage.controller";
import { Stack, Text } from "@bookingcom/bui-react";
import { CardAncillaries } from "@flights/search-ui";
import { formatFareName } from "@flights/branded-fares";

export const FlightCardLuggageMobile: FC<{
  flight: UIFlightData;
  brandedFareInfo?: UIBrandedFareInfo;
  align?: "start" | "end";
}> = ({ flight, brandedFareInfo, align = "end" }) => {
  const { luggageList } = useFlightCardLuggageController(flight);

  if (luggageList.length === 0) {
    return null;
  }

  return (
    <Stack gap={0.5} alignItems={align} attributes={{ style: { flexShrink: 0 } }}>
      {brandedFareInfo ? <BrandedFareDescription brandedFareInfo={brandedFareInfo} /> : undefined}
      <CardAncillaries ancillaries={luggageList} />
    </Stack>
  );
};

const BrandedFareDescription: FC<{ brandedFareInfo: UIBrandedFareInfo }> = ({ brandedFareInfo }) => {
  return (
    <Frame>
      <Text variant="small_1" align="end" color="neutral">
        {formatFareName(brandedFareInfo.fareName)}
      </Text>
    </Frame>
  );
};
